module.exports = __webpack_public_path__ + "img/iPhone12ProSilver.a28ba0fd.jpg";